import {TextArea} from '@dropbox/dig-components/text_fields';
import {Text} from '@dropbox/dig-components/typography';
import {Box, Stack} from '@dropbox/dig-foundations';
import {useTranslation} from 'react-i18next';
import {ApprovalMetadata} from 'views/admin/adminAiQueryApi';

/**
 * The generic part of an approval card: label/value rows, the body the action
 * writes (editable while the card is open), and an optional warning.
 */
export const ToolApprovalPreview = ({
  approval,
  body,
  editable,
  onBodyChange,
}: {
  approval: ApprovalMetadata;
  body: string;
  editable: boolean;
  onBodyChange: (value: string) => void;
}) => {
  const {t} = useTranslation();
  const fields = approval.preview_fields ?? [];

  return (
    <Stack gap="12">
      {fields.length > 0 && (
        <Stack gap="4">
          {fields.map((field) => (
            <Box key={field.label} display="flex" style={{gap: 8}}>
              <Box style={{minWidth: 72}}>
                <Text size="small" color="subtle">
                  {field.label}
                </Text>
              </Box>
              <Text size="small">{field.value}</Text>
            </Box>
          ))}
        </Stack>
      )}

      {approval.body_field && (
        <TextArea
          value={body}
          readOnly={!editable}
          rows={Math.min(12, Math.max(3, body.split('\n').length))}
          placeholder={t('approval_body_placeholder')}
          onChange={(e) => onBodyChange(e.currentTarget.value)}
        />
      )}

      {approval.warning && (
        <Text size="small" isBold>
          {approval.warning}
        </Text>
      )}
    </Stack>
  );
};
